module.exports = function linebreaksbr(input) {
  const re = new RegExp("\\n", "g")
  return input.replace(re, "<br>")
}
